module.exports = __webpack_public_path__ + "05_mustache_grey.9e6337dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/05_mustache_grey.png
// module id = DfjH
// module chunks = 0